import { useDispatch } from 'react-redux';
import { TDispatch } from '../types/referrer/store';

export const useReferrerAppDispatch: () => TDispatch = useDispatch;
